export default {
  en: {
    editPromotionRemark: 'Edit Promotion Remark',
    promotionList: 'Promotion',
    edit: 'Save Changes',
    cancel: 'Cancel',
    editPromotionRemarkSuccessTitle: 'Success',
    editPromotionRemarkSuccessMessage: 'Update Promotion Remark Success.'
  },
  th: {
    editPromotionRemark: 'แก้ไขหมายเหตุโปรโมชั่น',
    promotionList: 'รายการโปรโมชั่น',
    edit: 'บันทึก',
    cancel: 'ยกเลิก',
    editPromotionRemarkSuccessTitle: 'สำเร็จ',
    editPromotionRemarkSuccessMessage: 'แก้ไขหมายเหตุโปรโมชั่นสำเร็จ'
  }
}
